<div>
  <div class="filter-toolbar">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="table-top">
      <ifc-filters-active-list class="layout margin-sm" [filters]="activeFilters"
        (filterRemoved)="activeFilterRemoved($event)"></ifc-filters-active-list>
      <div fxHide.xs class="layout padding-right-md">
        <button mat-icon-button (click)="filterDialog()" matTooltip="Filter">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button mat-icon-button (click)="download(queryParams)" matTooltip="Download">
          <mat-icon>get_app</mat-icon>
        </button>
      </div>
      <div fxHide fxShow.xs>
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="filterDialog()">
            <mat-icon>filter_list</mat-icon>
            <span>Filter</span>
          </button>
          <button mat-menu-item (click)="download(queryParams)">
            <mat-icon>get_app</mat-icon>
            <span>Download</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <ifc-app-scroll-container [default]="true">
    <div class="table-container">
      <div class="message-box info" *ngIf="!data.customerQueryResult.totalCount" fxLayout="row" fxLayoutGap="12px"
        fxLayoutAlign="start center">
        <mat-icon class="icon">info</mat-icon>
        <span>No data found</span>
      </div>
      <table *ngIf="data.customerQueryResult.totalCount" mat-table matSort
        [dataSource]="data.customerQueryResult.values" (matSortChange)="sortData($event)">
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName"> First Name</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.firstName }}
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> Last Name</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.lastName }}
        </ng-container>
        <ng-container matColumnDef="uniqueId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="uniqueId"> Salesforce owner ID</th>
          <td mat-cell *matCellDef="let row" class="table-cell" >
            <a *ngIf="row.uniqueId" href="{{salesforceLink(row)}}" target="_blank"> {{row.uniqueId }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email"> Email</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.email}}
        </ng-container>
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Active</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.active }}
        </ng-container>
        <ng-container matColumnDef="loanNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="loanNumber"> Loan Number </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            <span *ngFor="let rows of row.loanDetails">
              <a *ngIf="canReadAccounts" [routerLink]="accountDetailsLink(rows.id)">{{rows.loanNumber}}</a>
              <span *ngIf="!canReadAccounts">{{rows.loanNumber}}</span> <br />
            </span>
        </ng-container>
        <ng-container matColumnDef="businessName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="loan.businessName"> Legal Entity Name </th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell">
            <span *ngFor="let rows of row.loanDetails">
              {{rows.businessName }} <br />
            </span>
        </ng-container>
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn"> Created On</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.createdOn |
            date: 'medium'}}
        </ng-container>
        <ng-container matColumnDef="updatedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="updatedOn"> Updated On</th>
          <td mat-cell *matCellDef="let row" (click)="customerDetailsLink(row)" class="table-cell"> {{row.updatedOn |
            date: 'medium'}}
        </ng-container>

        <ng-container matColumnDef="edit" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="customerDetailsLink(row, true)" class="action-icon">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true;" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;" class="clickable-row"></tr>
      </table>
    </div>
  </ifc-app-scroll-container>

  <div [hidden]="data.customerQueryResult.totalCount <= 10">
    <mat-paginator #paginator showFirstLastButtons [length]="data.customerQueryResult.totalCount"
      [pageSizeOptions]="[10, 20, 50]" (page)="setPage($event)"></mat-paginator>
  </div>

</div>
